/* แบบบ้าน */
import React from "react";
import { Col, Form, Image, Input, InputNumber, Row, Select } from "antd";
import CrudPage from "../../../components/ak/CrudPage";
import StatusTag from "../../../components/ak/StatusTag";
import ImageUpload from "../../../components/ak/ImageUpload";
import { HouseModelService } from "../../../service/Ak.service";
import { fileUrl, formatMoney } from "../../../utils/util";

const money = { formatter: (v) => (v === undefined || v === null || v === "" ? "" : `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), parser: (v) => `${v}`.replace(/,/g, "") };

export default function HouseModelPage() {
  return (
    <CrudPage
      title="แบบบ้าน"
      subtitle="แบบบ้านมาตรฐานของ AK-HOME — ใช้ตั้งต้นโปรเจ็กต์และ Template เลือกวัสดุ"
      menu="master_house_model"
      rowKey="model_code"
      service={HouseModelService}
      addText="เพิ่มแบบบ้าน"
      initialValues={{ floors: 1, build_days: 365 }}
      renderForm={(form, editing) => (
        <Row gutter={12}>
          <Col xs={24} md={8}>
            <Form.Item name="model_code" label="รหัสแบบบ้าน" rules={[{ required: true, message: "กรอกรหัส" }, { pattern: /^[A-Za-z0-9._-]+$/, message: "ใช้ได้เฉพาะ A-Z 0-9 . _ -" }]}>
              <Input maxLength={20} disabled={!!editing} placeholder="เช่น AK-101" />
            </Form.Item>
          </Col>
          <Col xs={24} md={16}>
            <Form.Item name="model_name" label="ชื่อแบบบ้าน" rules={[{ required: true, message: "กรอกชื่อแบบบ้าน" }]}>
              <Input maxLength={200} />
            </Form.Item>
          </Col>
          <Col xs={12} md={6}>
            <Form.Item name="floors" label="จำนวนชั้น">
              <InputNumber min={1} max={5} step={0.5} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={12} md={6}>
            <Form.Item name="bedrooms" label="ห้องนอน">
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={12} md={6}>
            <Form.Item name="bathrooms" label="ห้องน้ำ">
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={12} md={6}>
            <Form.Item name="usable_area" label="พื้นที่ใช้สอย (ตร.ม.)">
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="base_price" label="ราคาตั้งต้น (บาท)">
              <InputNumber min={0} style={{ width: "100%" }} {...money} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="build_days" label="ระยะเวลาก่อสร้าง (วัน)">
              <Select options={[{ value: 365, label: "365 วัน" }, { value: 450, label: "450 วัน" }, { value: 540, label: "540 วัน" }]} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="image_path" label="รูปแบบบ้าน">
              <ImageUpload type="house_model" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="description" label="รายละเอียด">
              <Input.TextArea rows={3} maxLength={4000} />
            </Form.Item>
          </Col>
          {editing && (
            <Col xs={24} md={8}>
              <Form.Item name="active_status" label="สถานะ">
                <Select options={[{ value: "Y", label: "ใช้งาน" }, { value: "N", label: "ปิดใช้งาน" }]} />
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
      columns={() => [
        { title: "", dataIndex: "image_path", width: 72, render: (v) => (v ? <Image src={fileUrl(v)} width={56} height={40} style={{ objectFit: "cover", borderRadius: 4 }} /> : null) },
        { title: "รหัส", dataIndex: "model_code", width: 110 },
        { title: "ชื่อแบบบ้าน", dataIndex: "model_name" },
        { title: "ชั้น", dataIndex: "floors", align: "center", render: (v) => (v ? Number(v) : "-") },
        { title: "นอน/น้ำ", key: "rooms", align: "center", render: (_, r) => `${r.bedrooms ?? "-"} / ${r.bathrooms ?? "-"}` },
        { title: "พื้นที่ (ตร.ม.)", dataIndex: "usable_area", align: "right", render: (v) => (v ? formatMoney(v, 0) : "-") },
        { title: "ราคาตั้งต้น", dataIndex: "base_price", align: "right", render: (v) => (v ? formatMoney(v, 0) : "-") },
        { title: "ก่อสร้าง", dataIndex: "build_days", align: "center", render: (v) => (v ? `${v} วัน` : "-") },
        { title: "โปรเจ็กต์", dataIndex: "project_count", align: "center" },
        { title: "สถานะ", dataIndex: "active_status", render: (v) => <StatusTag value={v} /> },
      ]}
    />
  );
}
